import React, {Component} from "react";

export class PrivatePage extends Component {
    render() {
        return <div><p>Private Page.</p></div>;
    }
}